import { Component, OnInit } from '@angular/core';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { BrandService, FREERATEUPDATE_LOGO_SVG } from '../../../../../../services/brand.service';

@Component({
    selector: 'app-mmlanding-header',
    templateUrl: '../../fru/form-landing-header/form-landing-header.component.html',
    styleUrls: ['../../fru/form-landing-header/form-landing-header.component.scss'],
    standalone: false
})
export class MMLandingHeaderComponent implements OnInit {

  officeStatus: OfficeStatus;
  readonly corporateLogoSrc = FREERATEUPDATE_LOGO_SVG;

  constructor(public brandService: BrandService) { }

  get corporateBrandOnly(): boolean {
    return this.brandService.domain === 'freerateupdate.com';
  }

  get coBrandLogoSrc(): string {
    const logoSrc = this.brandService.logoSrc;
    return [
      this.corporateLogoSrc,
      '/assets/images/logo.png',
      '/assets/images/fru-logo.svg',
    ].indexOf(logoSrc) >= 0 ? '' : logoSrc;
  }

  ngOnInit() {
  }
}
